var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartBarSolidLargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 3.36023V21.3602H21.75V3.36023H15.75ZM17.25 4.86023H20.25V19.8602H17.25V4.86023ZM2.25 7.86023V21.3602H8.25V7.86023H2.25ZM3.75 9.36023H6.75V19.8602H3.75V9.36023ZM9 12.3602V21.3602H15V12.3602H9ZM10.5 13.8602H13.5V19.8602H10.5V13.8602Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBarSolidLargeIcon);
export default __webpack_public_path__ + "static/media/chartBarSolidLargeIcon.f2e92c9cc061230369e23d195924b0d9.svg";
export { ForwardRef as ReactComponent };